import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NzMarks } from 'ng-zorro-antd/slider';

@Component({
  selector: 'liberro-slider',
  standalone: false,
  templateUrl: './liberro-slider.component.html',
  styleUrl: './liberro-slider.component.less',
})
export class LiberroSliderComponent {
  @Input() public min = 0;
  @Input() public max = 100;
  @Input() public step = 1;
  @Input() public marks: NzMarks | null = null;
  @Input() public dots = false;
  @Input() public disabled = false;
  @Input() public control!: FormControl<number>;
}

